class ReferalService {
  title: string;
  id: string;
  link: string;
  constructor(service: string, title: string) {
    this.title = title;
    this.id = `${service}-input`;
    this.link = `https://seeneco.com/ru/${service}/?ref=`
  }
}

const BFM_REFERAL_SERVICE = new ReferalService("bfm", "Сервис управленческого учета и бизнес-аналитики")
const ACQUIRING_REFERAL_SERVICE = new ReferalService("acquiring", "Сервис выставления счетов и приема платежей")

export const refLinks = [
  BFM_REFERAL_SERVICE,
  ACQUIRING_REFERAL_SERVICE,
];